import {Component, Input} from "@angular/core";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {catchError} from "rxjs/operators";
import {throwError} from "rxjs";
import {NavigationExtras, Router} from "@angular/router";
import {ApiAwareHttpClient} from "../../../shared/services/api_aware_http_client";
import {SharedApiService} from "../../../shared/services/api.service";
import {NoPartnerOrganisationModalComponent} from "../../../shared/components/no-partner-organisation-modal/no-partner-organisation-modal.component";

@Component({
    templateUrl: './login-modal.component.html',
    styleUrls: [
        './login-modal.component.scss'
    ]
})
export class LoginModalComponent {
    @Input() public currentRoute: any;

    public credentials = {
        username: '',
        password: '',
    };

    public reason: string | null;

    constructor(
        public modal: NgbActiveModal,
        private apiClient: ApiAwareHttpClient,
        private apiService: SharedApiService,
        private router: Router,
        private modalService: NgbModal,
    ) {
    }

    public login() {
        this.apiClient.login(
            this.credentials.username,
            this.credentials.password,
            {dispatchError: false}
        ).pipe(
            catchError((err: any) => {
                if (err.status === 401) {
                    this.reason = 'unauthorized';
                } else {
                    this.apiClient.catchError({})(err);
                }
                return throwError(err);
            })
        ).subscribe(_x => {
            this.apiService.getCurrentSigPartner().subscribe(sigPartner => {
                const navigationExtras: NavigationExtras = {
                    state: {
                        hasTermsAndConditionsAccepted: (sigPartner['termsAndConditionsAccepted'] !== null),
                        hasPriceUpdates: sigPartner['hasPriceUpdates'],
                    }
                };

                if (sigPartner['organisation'] === null) {
                    this.modalService.open(NoPartnerOrganisationModalComponent);
                }
            });

            this.router.navigate([this.currentRoute]);
            this.close();
        });
    }

    public close() {
        this.modal.dismiss();
    }
}
